import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Message = () => import("../components/content/messages/message");
const NewMessage = () => import("../components/content/messages/newMessage");
const MessageThread = () =>
  import("../components/content/messages/messageThread");
const AccountOfficer = () =>
  import("../components/content/messages/accountOfficer");

export const messageRoute = {
  path: "/messaging",
  component: Message,
  children: [
    {
      path: "",
      component: AccountOfficer
    },
    {
      path: "/new-message",
      component: NewMessage
    },
    {
      path: "/message-thread",
      component: MessageThread
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
